export enum HubSpotFetchType {
	GetAssociations,
	GetAssociationsById,
	WhereFilter,
}
